import { useModals } from 'almanac-ui/Modal'
import { Voice } from 'blaze-ui/icons/16'
import { ChangeToneModal } from 'components/BlazeCommandLine/modals/ChangeToneModal'
import { Button } from 'components/Button'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { AllSelection } from 'prosemirror-state'
import { EditorView } from 'prosemirror-view'
import { useAlmanacEditorState } from 'stores/EditorState'

interface Props {
  articleId: string
  layerId: string
  view: EditorView
}

export const ChangeToneAction = ({ articleId, layerId, view }: Props) => {
  const { openModal } = useModals()
  const selection = new AllSelection(view.state.doc).toJSON()
  const almanacEditorState = useAlmanacEditorState() || undefined
  const { isMobile } = useResponsiveDesign()

  const handlePress = () => {
    openModal(ChangeToneModal, {
      articleId,
      layerId,
      selection,
      almanacEditorState,
    })
  }

  return (
    <Button
      aria-label="Change tone"
      variant="tertiary"
      size="lg"
      frontIcon={() => <Voice size={24} />}
      onPress={handlePress}
      id="change-tone"
    >
      {isMobile ? 'Tone' : 'Voice & Tone'}
    </Button>
  )
}
